import React                     from 'react';
import PropTypes                 from 'prop-types';
import Translations              from '../../../../../utils/Translations';
import {formatEffectAsPlainText} from '../../../../Dailybonus/dailyBonusHelpers';

class DailybonusMerchOfferDescr extends React.Component {
	render() {
		const {effect} = this.props;
		return (
			<div className='dailybonus__mobile--item__description'>
				<div className="dailybonus__mobile--item__description--bonus-effect">{formatEffectAsPlainText(effect)}</div>
				<div className="dailybonus__mobile--item__description--bonus-title">{Translations.get('OnAll365')}</div>
				<div className="dailybonus__mobile--item__description--bonus-info h-text-light">{Translations.get('InMerchShop365')}</div>
			</div>
		);
	}
}

DailybonusMerchOfferDescr.propTypes = {
	effect: PropTypes.object,
};

export default DailybonusMerchOfferDescr;